import { useState, useEffect } from 'react';

import apis from '@/apis';

export default function useCagegory() {
  const [categoryData, setCategoryData] = useState({
    values: [],
    loading: true,
  });

  useEffect(() => {
    apis.fetchCategories({ pageSize: 1000 }).then((res) => {
      if (res && res.ret === '0') {
        setCategoryData({
          loading: false,
          values: res.data.categorys,
        });
      } else {
        setCategoryData({
          loading: false,
          values: [],
        });
      }
    });
  }, []);

  return [categoryData.loading, categoryData.values];
}
